import { createAsyncThunk } from '@reduxjs/toolkit';
import {
  getWaterChangeStandardByFacility,
  setWaterChangeStandardForFacilities,
} from '../../services/apiServices';

/**
 * waterChangeStandardThunks
 *
 * Defines async actions for loading and persisting the water change standard
 * for one or more facilities.
 *
 * fetchWaterChangeStandard(facilityId):
 *  • GET /web-api/water_change_standard/:facilityId
 *  • On 404, resolves with an empty standard
 *  • Other errors propagate via rejectWithValue
 *
 * saveWaterChangeStandard({ facilityIds, standard }):
 *  • POST /web-api/water_change_standard/water_change_standard/
 *  • Returns the list of updated facility IDs
 *  • Errors propagate via rejectWithValue
 */
export const fetchWaterChangeStandard = createAsyncThunk(
  'waterChangeStandard/fetch',
  async (facilityId, { rejectWithValue }) => {
    try {
      const data = await getWaterChangeStandardByFacility(facilityId);
      return { facilityId, standard: data.standard };
    } catch (error) {
      if (error.response?.status === 404) {
        return { facilityId, standard: '' };
      }
      return rejectWithValue(error.message);
    }
  },
);

export const saveWaterChangeStandard = createAsyncThunk(
  'waterChangeStandard/save',
  async ({ facilityIds, standard }, { rejectWithValue }) => {
    try {
      const data = await setWaterChangeStandardForFacilities(facilityIds, standard);
      return data.updated_facilities;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);
